import React from "react";
import { connect } from "react-redux";
import { baseUrl } from "env";
class CommercialBanner extends React.Component {
  render = () =>
    this.props.config.top_header_banner_media_id ? (
      <div className="container banner_holder">
        <img
          alt=""
          src={`${baseUrl}/api/media/media/${
            this.props.config.top_header_banner_media_id
          }`}
        />
      </div>
    ) : null;
}

const mapStateToProps = state => ({
  config: state.config ? state.config.data : {},
  screen: state.screen
});
export default connect(mapStateToProps)(CommercialBanner);
